import { UI_SETTINGS_CONSTANTS } from '@/constants/uiSettingsConstants'

const initialState = {
  loading: false,
  error: null,
  settings: {
    id: null,
    salesperson_id: null,
    lines_per_page: 20,
    email_signature: '',
    email_template: '',
    partnumber_highlight_enabled: true,
    onpage_notes: false,
    hide_deleted_line_items: false,
    // Quote "Show CPN" display option; defaults to shown (matches the old local default)
    show_customer_part_number: true,
    tagged_company: null,
    match_confidence_criteria: {
      flag_availability_zero: true,
      flag_missing_identifier: true,
      flag_descriptive_no_exact: true,
      flag_identifier_availability_zero: true,
      flag_high_value_item: true,
      flag_wirecut_no_length: true,
      flag_qty_below_moq: true
    }
  },
  updateLoading: false,
  updateError: null,
  updateSuccess: false,
  taggedCompanies: {
    loading: false,
    error: null,
    loaded: false,
    data: []
  }
}

// Fetch UI Settings Reducer
export const uiSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UI_SETTINGS_CONSTANTS.FETCH_UI_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case UI_SETTINGS_CONSTANTS.FETCH_UI_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        settings: {
          ...state.settings,
          ...action.payload
        }
      }
    case UI_SETTINGS_CONSTANTS.FETCH_UI_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case UI_SETTINGS_CONSTANTS.UPDATE_UI_SETTINGS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null,
        updateSuccess: false
      }
    case UI_SETTINGS_CONSTANTS.UPDATE_UI_SETTINGS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: null,
        updateSuccess: true,
        settings: {
          ...state.settings,
          ...action.payload
        }
      }
    case UI_SETTINGS_CONSTANTS.UPDATE_UI_SETTINGS_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload,
        updateSuccess: false
      }
    case UI_SETTINGS_CONSTANTS.FETCH_TAGGED_COMPANIES_REQUEST:
      return {
        ...state,
        taggedCompanies: {
          ...state.taggedCompanies,
          loading: true,
          error: null
        }
      }
    case UI_SETTINGS_CONSTANTS.FETCH_TAGGED_COMPANIES_SUCCESS:
      return {
        ...state,
        taggedCompanies: {
          ...state.taggedCompanies,
          loading: false,
          error: null,
          loaded: true,
          data: action.payload
        }
      }
    case UI_SETTINGS_CONSTANTS.FETCH_TAGGED_COMPANIES_FAIL:
      return {
        ...state,
        taggedCompanies: {
          ...state.taggedCompanies,
          loading: false,
          error: action.payload,
          loaded: true,
          data: []
        }
      }
    case UI_SETTINGS_CONSTANTS.RESET_UI_SETTINGS:
      return initialState
    default:
      return state
  }
}
